import * as S from "@/containers/Project/components/styled";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { Button, Modal } from "antd";
import { useIntl } from "react-intl";
import { IErrorProps } from "../../interfaces";

interface IProps {
  modalState: IErrorProps;
  closeModal: () => void;
}
const MilestoneErrorModal = ({ modalState, closeModal }: IProps) => {
  const intl = useIntl();
  return (
    <Modal
      open={modalState.visible}
      title={modalState.title}
      width={600}
      closable
      maskClosable
      onCancel={(): void => {
        closeModal();
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={(): void => {
            closeModal();
          }}
          data-test-id="milestone-error-modal-ok"
        >
          {intl.formatMessage({ id: "general.close" })}
        </Button>,
      ]}
    >
      <S.CenteredIconContainer>
        <S.DocumentsRequiredAlertIcon
          icon={faTriangleExclamation as IconProp}
        />
      </S.CenteredIconContainer>
      <S.MilestoneSubmitModalTextContainer>
        {modalState.description}
        {modalState.errors.map((message, index) => (
          <div className="font-bold" key={index}>
            {message}
          </div>
        ))}
      </S.MilestoneSubmitModalTextContainer>
    </Modal>
  );
};

export { MilestoneErrorModal };
